import { useEffect } from 'react'

import * as Bridge from '@/api/BridgeApi'
import { useFetchDispatch } from '@/hooks/useFetchDispatch'
import { goBack } from '@/utils/historyUtils'

export const useBackButton = (callback: () => void) => {
  useFetchDispatch(
    () => {
      Bridge.onBackPressed(callback)
    },
    [],
    { componentDidMountCondition: true, componentDidUpdateCondition: false },
  )

  useEffect(() => {
    return () => {
      Bridge.onBackPressed(() => {
        goBack()
      })
    }
  }, [])
}
